// @flow strict

/**
 * decode a Base64 encoded string, or return original input if window.atob is not available
 * input is assumed to have been encoded with UserInterfaceUtil::obfuscateWord
 * customRandomCharCount can be specified for input encoded by other means
 */
const decodeString = (input: string) => {
  // UserInterfaceUtil::obfuscateWord prepends/appends random characters, such that the link, pre-encoded, looks similar
  // to xxxx_/ActualLinkText_xxxx
  const randomCharCount = 4;

  // eslint-disable-next-line ta-code-conventions/lithium-string-blacklist
  if (SERVER || input == null) {
    // SHOULD NOT DECODE ANYTHING ON SERVER SIDE
    return input;
  }
  try {
    // eslint-disable-next-line no-restricted-globals
    const decodedUrl = window.atob(input);
    const output = decodedUrl.substring(randomCharCount, decodedUrl.length - randomCharCount);

    return output;
  } catch (e) {
    console.error(
      `Error during decoding - likely you are calling this with an already decoded string! Original input: ${input}, error: ${e}`,
    );
    return input;
  }
};

export default decodeString;
